import IScroll from '../Iscroll';
import IScrollProbe from '../Iscroll/build/iscroll-probe';

export default IScroll(IScrollProbe);